<template>
  <v-layout wrap>
    <v-flex xs12>
      <v-toolbar dense color="toolbarColor" class="jobTab">
        <v-btn 
          v-for="item in menu"
          :key="item.link"
          :to="item.link"
          :color="item.color"
          round
          md-small
          sm-large
          flat
        >{{ item.name }}</v-btn>
      </v-toolbar>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "SonkoJobsMenu",
  data() {
    return {
      menu: [
        { name: "Active Jobs", color: "blue", link: "/sonko/jobs/active" },
        { name: "Assigned Jobs", color: "green", link: "/sonko/jobs/assigned" },
        { name: "Expired Jobs", color: "red", link: "/sonko/jobs/expired" }
      ]
    };
  }
};
</script>

<style scoped>
.menu {
  padding-left: 150px;
}
</style>